import { SortDirection } from '../../list-conductor/sort';
import { AlphabeticalAsc } from '../../list-conductor/SortDropdown/AlphabeticalAsc';
import { AlphabeticalDesc } from '../../list-conductor/SortDropdown/AlphabeticalDesc';
import { SortDropdownOption } from '../../list-conductor/SortDropdown/interface';
import { Newest } from '../../list-conductor/SortDropdown/Newest';
import { Oldest } from '../../list-conductor/SortDropdown/Oldest';

export const PIPELINE_SORT_DROPDOWN_OPTIONS: SortDropdownOption[] = [
  {
    label: Newest,
    key: 'id',
    direction: SortDirection.DESC
  },
  {
    label: Oldest,
    key: 'id',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalAsc,
    key: 'name',
    direction: SortDirection.ASC
  },
  {
    label: AlphabeticalDesc,
    key: 'name',
    direction: SortDirection.DESC
  }
];
